import { createBrowserRouter, Outlet } from "react-router-dom";
import { GameScreen } from "~/ui/screens/game-screen";
import { TitleScreen } from "~/ui/screens/title-screen";
import { Toaster } from "~/ui/system/toast";

export const router = createBrowserRouter([
  {
    element: <Wrapper />,
    children: [
      {
        path: "/",
        element: <TitleScreen />,
      },
      {
        path: "/play",
        element: <GameScreen />,
      },
    ],
  },
]);

function Wrapper() {
  return (
    <>
      <Outlet />
      <Toaster />
    </>
  );
}
